import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Chapter } from "@/components/landing/Chapter";

export const FAQS = [
  {
    q: "Où se trouve le garage AUTO MECA PRO ?",
    a: "Notre atelier AMP Services 01 est situé au 56 Avenue d'Oyonnax, 01100 Bellignat (Ain), à 2 minutes du centre d'Oyonnax sur l'axe Nantua – Genève. Parking client gratuit sur place.",
  },
  {
    q: "Quels sont les horaires d'ouverture du garage ?",
    a: "Du lundi au vendredi de 9h à 12h et de 14h à 19h, et le samedi de 9h à 14h. Fermé le dimanche. Pour toute question, appelez le 04 26 61 27 33 ou écrivez à contact@automecapro01.com.",
  },
  {
    q: "Le devis est-il vraiment gratuit ?",
    a: "Oui. Chaque intervention fait l'objet d'un devis gratuit et détaillé, validé par vous avant tout travaux. Aucune réparation n'est engagée sans votre accord : c'est notre engagement de transparence.",
  },
  {
    q: "Réparez-vous toutes les marques de voitures ?",
    a: "Oui, notre garage de Bellignat est multimarque : essence, diesel et hybride. Grâce à nos valises de diagnostic dernière génération et à des pièces d'origine ou de qualité équivalente, votre garantie constructeur est préservée.",
  },
  {
    q: "Comment profiter des 200€ offerts pour un changement de pare-brise ?",
    a: "Pour tout changement de pare-brise réalisé dans notre atelier, nous vous offrons 200€. Nous nous occupons également du dossier avec votre assurance bris de glace. Contactez-nous pour connaître les conditions de l'offre du moment.",
  },
  {
    q: "Vendez-vous des véhicules d'occasion ?",
    a: "Oui, nous proposons des véhicules d'occasion sélectionnés, révisés dans notre atelier et garantis. Retrouvez toutes nos annonces à jour sur notre boutique leboncoin ou directement au garage.",
  },
];

const Item = ({ faq, open, onToggle, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
    className={`rounded-md border transition-colors duration-300 ${
      open ? "border-[#0066FF]/60 bg-[#0E1322]" : "border-white/10 bg-[#0E1322]/50 hover:border-white/25"
    }`}
    data-testid={`faq-item-${index}`}
  >
    <button
      data-testid={`faq-question-${index}`}
      onClick={onToggle}
      className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
    >
      <span className="font-display font-bold text-base md:text-lg tracking-tight">{faq.q}</span>
      <Plus
        className={`w-5 h-5 shrink-0 text-[#00E5FF] transition-transform duration-300 ${open ? "rotate-45" : ""}`}
      />
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          className="overflow-hidden"
        >
          <p className="px-6 pb-6 text-sm md:text-base text-slate-300 leading-relaxed" data-testid={`faq-answer-${index}`}>
            {faq.a}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  </motion.div>
);

export const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 lg:py-36">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <Chapter num="05" title="Questions fréquentes" accent="Garage à Bellignat, près d'Oyonnax" />
        <div className="space-y-4">
          {FAQS.map((faq, i) => (
            <Item
              key={faq.q}
              faq={faq}
              index={i}
              open={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
